import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedList from './components/FeaturedList';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedList />
        <CategoryNav />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}